// jQuery(function () {

window.addEventListener('DOMContentLoaded', function () {

    const loadAdsBasedOnDevice = () => {
        const isDefaultPostTemplate = document.querySelector('body').classList.contains('post-template-default');
        if (awIsMobile() && adw?.post?.post_type === 'post' && isDefaultPostTemplate) {

            // If device is mobile and
            // the post type is post
            // then load Ads as user scrolls

            let adsLoaded = false;

            // Test via a getter in the options object to see if the passive property is accessed
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, 'passive', {
                    get: function () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassive", null, opts);
                window.removeEventListener("testPassive", null, opts);
            } catch (e) { }

            // Use our detect's results. passive applied if supported, capture will be false either way.
            const listenerOptions = {
                once: true
            }

            if (supportsPassive) {
                listenerOptions.passive = true;
            }

            window.addEventListener('scroll', function () {

                console.log('Loading Ads...');
                if (!adsLoaded) {
                    loadAdsWithConfig();
                    adsLoaded = true;
                }

            }, listenerOptions);

        } else {
            loadAdsWithConfig();
        }
    }

    const loadAdsWithConfig = () => {
        if (typeof window.awLoadAds !== 'undefined') {
            if (typeof otGeoContinent !== 'undefined' && otGeoContinent === 'EU' && typeof OnetrustActiveGroups !== 'undefined') {
                window.awLoadAds({
                    usePersonalizedAds: OnetrustActiveGroups.includes('C0004')
                });
            } else {
                window.awLoadAds({
                    usePersonalizedAds: true
                });
            }
        } else {
            console.error('awLoadAds is undefined');
        }
    }

    (function ($) {
        console.log('pre awLoadAds function call');
        if (!adw.is_user_logged_in) {

            // loadAdsBasedOnDevice();
            loadAdsWithConfig();

            window.lytics = window.lytics || {};
            window.lytics.fields = window.lytics.fields || {};

            var userCountryCode = 'unknown';
            var locationCookie = Cookies.get('locationCookie');

            var locationData = {
                ip: 'unknown',
                country: {
                    iso_code: 'unknown'
                }
            };

            function awProcessUserLocation(locationData) {

                if (locationData && locationData.country && locationData.country.iso_code) {
                    userCountryCode = locationData.country.iso_code;

                    $(document).trigger('aw-location-detected', locationData);

                }
                window.lytics.fields.attr_user_country_code = userCountryCode;
            }

            if (typeof locationCookie !== 'undefined') {
                var parsedCookie = JSON.parse(locationCookie);
                locationData.ip = parsedCookie.ip;
                locationData.country.iso_code = parsedCookie.country.iso_code;
                $(document).trigger('aw-ip-detected', locationData.ip);
                $('head').append('<meta name="ipaddr" value="' + locationData.ip + '" />');
                awProcessUserLocation(locationData);
            }

        } else {
            if (typeof window.awLoadAds !== 'undefined') {
                window.awLoadAds({
                    usePersonalizedAds: true
                });
            } else {
                console.error('awLoadAds is undefined');
            }
        }

    })(jQuery);

});